export const BasicPage = ({ title, icon }) => {
  return (
    <main id="main">
      {icon}
      {title}
    </main>
  );
};
